import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Icon } from "@iconify/react";
import AnimatedCard from "../components/AnimatedCard";
import EarlyAdopter1 from "../assets/images/earlyAdopters1.jpg";
import EarlyAdopter2 from "../assets/images/earlyAdopters2.jpg";
import EarlyAdopter3 from "../assets/images/earlyAdopters3.jpg";
import EarlyAdopter4 from "../assets/images/earlyAdopters4.jpg";
import Quarterly from "../assets/images/quarterly.png";
import Quarterly2 from "../assets/images/quarterly2.png";
import FormImg from "../assets/images/PHOTO.png";
import BildIcon from "../assets/images/Bildup-Icon.svg";
import FaqData from "../components/FaqData";
import Footer from "../components/Footer";
import axiosClient from "../api/axiosClient";
import { useToast } from "../context/ToastContext";
import SuccessImg from "../assets/images/student.png";

const Pricing = () => {
  const [billingPeriod, setBillingPeriod] = useState("monthly");
  const [showSignupModal, setShowSignupModal] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { addToast } = useToast();
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [activeTab, setActiveTab] = useState("learner");

  const [countries, setCountries] = useState([]);
  const [isLoadingCountries, setIsLoadingCountries] = useState(false);
  const [searchCountry, setSearchCountry] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const [countryFlag, setCountryFlag] = useState(null);

  const [selectedInterests, setSelectedInterests] = useState([]);

  useEffect(() => {
    const fetchCountries = async () => {
      setIsLoadingCountries(true);
      try {
        const response = await fetch("https://restcountries.com/v3.1/all");
        const data = await response.json();
        const sortedCountries = data
          .sort((a, b) => a.name.common.localeCompare(b.name.common))
          .map((country) => ({
            name: country.name.common,
            flag: country.flags.svg,
            code: country.cca2,
          }));
        setCountries(sortedCountries);
      } catch (error) {
        console.error("Error fetching countries:", error);
      } finally {
        setIsLoadingCountries(false);
      }
    };

    fetchCountries();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest(".country-dropdown")) {
        setShowDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (activeTab === "learner") {
      // setFormData(prev => ({
      //   ...prev,
      //   profile: "parent/student"
      // }));
    } else {
      setSchoolFormData(prev => ({
        ...prev,
        profile: "educator"
      }));
    }
  }, [activeTab]);

  // Form state
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    hear_about_us: "",
    interests: "",
    profile:"",
    selected_plan: "",
  });

  const [schoolFormData, setSchoolFormData] = useState({
    school_name: "",
    city: "",
    country: "",
    state: "",
    first_name: "",
    last_name: "",
    contact_person_role: "",
    number: "",
    // student_count: "",
    // school_email: "",
    email: "",
    selected_plan: "",
    profile: "",
    interests: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSchoolChange = (e) => {
    const { name, value } = e.target;
    setSchoolFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleInterestChange = (e) => {
    const { value, checked } = e.target;
    setSelectedInterests((prev) => {
      if (checked) {
        return [...prev, value];
      }
      return prev.filter((item) => item !== value);
    });

    // Update the schoolFormData with concatenated interests
    handleSchoolChange({
      target: {
        name: "interests",
        value: checked
          ? [...selectedInterests, value].join(", ")
          : selectedInterests.filter((item) => item !== value).join(", "),
      },
    });
  };

  const handlePlanSelect = (plan) => {
    setSelectedPlan(plan);
    setFormData((prevState) => ({
      ...prevState,
      selected_plan: plan,
    }));
    setShowSignupModal(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // Show loading state (optional)
      setIsLoading(true);

      // Send data to the server using axiosClient
      const response = await axiosClient.post("/waitlist", formData);

      // Handle success
      addToast({
        type: "success",
        title: "Success",
        content:
          "Your information has been submitted! We will contact you shortly.",
      });

      setFormData({
        first_name: "",
        last_name: "",
        email: "",
        phone: "",
        hear_about_us: "",
        interests: "",
        profile:"",
        selected_plan: "",
      })

      // Show success message
      setShowSignupModal(false);
      setTimeout(() => {
        setShowConfirmationModal(true);
      }, 1000);
    } catch (error) {
      // Handle error
      console.error("Error submitting form:", error);
      addToast({
        type: "error",
        title: "Error !",
        content:
          error.response.data.message ||
          "There was an error submitting your information. Please try again later.",
      });
    } finally {
      // Hide loading state (optional)
      setIsLoading(false);
    }
  };

  const handleSchoolSubmit = async (e) => {
    e.preventDefault();

    try {
      // Show loading state (optional)
      setIsLoading(true);

      // Send data to the server using axiosClient
      const response = await axiosClient.post("/waitlist", schoolFormData);

      // Handle success
      console.log("School form submitted successfully", response.data);
      addToast({
        type: "success",
        title: "Success",
        content:
          "Your information has been submitted! We will contact you shortly.",
      });

      setSchoolFormData({
        school_name: "",
        city: "",
        country: "",
        state: "",
        first_name: "",
        last_name: "",
        contact_person_role: "",
        number: "",
        // student_count: "",
        // school_email: "",
        email: "",
        selected_plan: "",
        profile: "",
        interests: "",
      })
      // Show success message
      setShowSignupModal(false);
      setTimeout(() => {
        setShowConfirmationModal(true);
      }, 1000);
    } catch (error) {
      // Handle error
      console.error("Error submitting school form:", error);
      addToast({
        type: "error",
        title: "Error !",
        content:
          error.response.data.message ||
          "There was an error submitting your information. Please try again later.",
      });
    } finally {
      // Hide loading state (optional)
      setIsLoading(false);
    }
  };

  const faqs = [
    {
      id: 1,
      question: "What subject does this subscription cover?",
      answer:
        "This subscription currently supports mathematics, aligned with national and international curricula. More subjects are being added regularly to ensure comprehensive learning support.",
    },
    {
      id: 2,
      question: "Do we offer school or group subscription?",
      answer:
        "Absolutely, we offer custom pricing and onboarding support for schools, learning centers, and groups. If you're an administrator or educator, contact us to learn more about bulk access and educational partnerships.",
    },
    {
      id: 3,
      question: "Will Bildup AI work on any device?",
      answer:
        "Bildup AI is designed to work smoothly across tablet and computers. You just need a stable internet connection and the Bildup App to get started.",
    },
  ];

  return (
    <div className="pt-16 blue-linear">
      <div className="md:px-24 px-5">
        <div className="md:mt-15 mt-10 text-center mb-4">
          <span className="p-3 text-primary-purple-200 rounded-full bg-gray-200">
            Early Access Discount
          </span>
          <h1 className="md:text-[40px] text-[20px] text-gradient-green-purple font-bold mt-3">
            Unlock Learning Without Limits
          </h1>
        </div>

        <div className="grid md:grid-cols-2 grid-cols-1 gap-6 h-fit">
          <div className="flex flex-col gap-3 h-[60vh]">
            <AnimatedCard
              className="h-[30%] bg-primary-purple-200 text-white rounded-lg"
              direction="right"
            >
              <p className="text-[16px] md:text-[24px] p-6">
                Choose a plan that supports your learning journey with Bildup AI
              </p>
            </AnimatedCard>

            <AnimatedCard className="h-[70%]" direction="right" delay={1}>
              <img
                src={EarlyAdopter1}
                alt="Early Adopters"
                className="w-full h-full object-cover rounded-lg"
              />
            </AnimatedCard>
          </div>

          <div className="flex md:flex-col-reverse flex-col gap-3 h-[60vh]">
            <AnimatedCard
              className="h-[30%] bg-yellow-300 text-black rounded-lg"
              direction="right"
            >
              <p className="text-[16px] md:text-[24px] p-6">
                Bildup AI adapts, encourages and grows with every learner.
              </p>
            </AnimatedCard>

            <AnimatedCard className="h-[70%]" direction="right" delay={1}>
              <img
                src={EarlyAdopter2}
                alt="Early Adopters"
                className="w-full h-full object-cover rounded-lg"
              />
            </AnimatedCard>
          </div>
        </div>

        <h1 className="text-4xl  text-gray-500 mb-8 text-center mt-16">
          Select a plan to start your{" "}
          <span className="text-primary-purple-400">14-day free trial</span>
        </h1>

        {/* Billing toggle - smoother transition */}
        <div className="flex justify-center mb-10" id="bill">
          <motion.div
            className="bg-gray-100 rounded-full p-1 flex"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <motion.button
              className={`px-6 py-2 rounded-full ${billingPeriod === "monthly"
                  ? "bg-primary-purple-200 text-white"
                  : "text-gray-700"
                }`}
              onClick={() => setBillingPeriod("monthly")}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Monthly
            </motion.button>
            <motion.button
              className={`px-6 py-2 rounded-full ${billingPeriod === "quarterly"
                  ? "bg-primary-purple-200 text-white"
                  : "text-gray-700"
                }`}
              onClick={() => setBillingPeriod("quarterly")}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Quarterly
            </motion.button>
          </motion.div>
        </div>

        {/* Pricing cards - centered with smoother transitions */}
        <div className="flex justify-center mb-16">
          <AnimatePresence mode="wait">
            {billingPeriod === "monthly" ? (
              <AnimatedCard
                key="monthly"
                className="w-full max-w-md mx-auto"
                direction="fadeIn"
                duration={0.7}
                distance={0}
              >
                <motion.div
                  className="p-6 bg-purple-50 rounded-lg shadow-lg text-left cursor-pointer relative overflow-hidden"
                  onClick={() => handlePlanSelect("Monthly")}
                  whileHover={{
                    y: -5,
                    boxShadow:
                      "0 10px 25px -5px rgba(124, 58, 237, 0.1), 0 10px 10px -5px rgba(124, 58, 237, 0.04)",
                  }}
                  transition={{ type: "spring", stiffness: 300 }}
                >
                  <div className="absolute top-5 right-5">
                    <div
                      style={{
                        backgroundImage: `url(${Quarterly2})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                      }}
                      className="rounded-full w-24 h-24 flex items-center justify-center z-10"
                    >
                      <div className="text-center text-white text-s">
                        <div>2 weeks</div>
                        <div>free</div>
                      </div>
                    </div>
                  </div>

                  <h5 className="text-xl font-medium text-gray-700">Monthly</h5>

                  <div className="mt-2 text-gray-500 line-through">
                    ₦ 16,000
                  </div>

                  <div className="flex items-baseline mt-10">
                    <span className="text-5xl  text-purple-500">₦ 7,000</span>
                    <span className="text-gray-500 ml-2">/month</span>
                  </div>

                  <motion.button
                    className="w-full bg-purple-500 text-white font-medium rounded-full py-3 mt-10"
                    whileHover={{ scale: 1.02 }}
                    whileTap={{ scale: 0.98 }}
                  >
                    Start 14-day free trial
                  </motion.button>

                  <p className="text-gray-700  text-[20px] mt-12">
                    This payment grants full access to the mathematics
                    curriculum
                  </p>
                </motion.div>
              </AnimatedCard>
            ) : (
              <AnimatedCard
                key="quarterly"
                className="w-full max-w-md mx-auto"
                direction="fadeIn"
                duration={0.7}
                distance={0}
              >
                <motion.div
                  className="p-6 bg-quarterly rounded-lg shadow-lg text-left cursor-pointer relative overflow-hidden bg-cover bg-center"
                  onClick={() => handlePlanSelect("Quarterly")}
                  whileHover={{
                    y: -5,
                    boxShadow:
                      "0 15px 30px -5px rgba(124, 58, 237, 0.3), 0 10px 10px -5px rgba(124, 58, 237, 0.2)",
                  }}
                  transition={{ type: "spring", stiffness: 300 }}
                >
                  {/* <div className="absolute inset-0  gradient-primary"></div>
                  <div className="absolute inset-0  opacity-30  h-10 w-10 bg-[url('./assets/images/quarterlyBg.png')] bg-repeat-y bg-contain bg-center"></div> */}

                  <div className="absolute top-5 right-5">
                    <div
                      style={{
                        backgroundImage: `url(${Quarterly})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                      }}
                      className="rounded-full w-24 h-24 flex items-center justify-center z-10"
                    >
                      <div className="text-center text-primary-purple-200 text-s">
                        <div>2 weeks</div>
                        <div>free</div>
                      </div>
                    </div>
                  </div>

                  <h5 className="text-xl font-medium text-white z-10">
                    Quarterly
                  </h5>

                  <div className="mt-2 text-purple-200 line-through z-10">
                    ₦ 42,000
                  </div>

                  <div className="flex items-baseline mt-10 z-10">
                    <span className="text-5xl  text-white">₦ 18,000</span>
                    <span className="text-purple-200 ml-2">/month</span>
                  </div>

                  <motion.button
                    className="w-full bg-white z-10 text-purple-500 font-medium rounded-full py-3 mt-12"
                    whileHover={{ scale: 1.02 }}
                    whileTap={{ scale: 0.98 }}
                  >
                    Start 14-day free trial
                  </motion.button>

                  <p className="text-white mt-6 text-[20px] ">
                    This payment grants full access to the mathematics
                    curriculum
                  </p>
                </motion.div>
              </AnimatedCard>
            )}
          </AnimatePresence>
        </div>

        <AnimatedCard className="md:px-24" direction="bottom">
          <FaqData faqs={faqs} />
        </AnimatedCard>

        <AnimatedCard className="flex flex-col items-center justify-center">
          <h1 className="md:text-[40px] text-[20px] text-center md:w-[70%] w-[90%] mb-6 mt-16 text-primary-purple-200 ">
            Helping Your Child Learn and Grow With Confidence
          </h1>
          <img
            src={EarlyAdopter4}
            alt=""
            srcSet=""
            className="rounded-lg md:w-[70%]  md:h-[65vh] h-[40vh] w-[100%] "
          />
        </AnimatedCard>

        <AnimatedCard className="md:px-24 mt-10 mb-8" direction="bottom">
          <div className="rounded-lg bg-primary-purple-200 flex  h-fit overflow-hidden">
            <div className="md:w-[60%] w-[70%] p-10 text-white  flex flex-col gap-4">
              <h1 className="md:text-[40px] leading-tight sm:text-[20px] ">
                Ready to Give Your Child an Edge?
              </h1>
              <p className="md:text-[20px] text-[12px] h-fit">
                Start your 14-day trial on our child safe platform aligned with
                national and international standard.
              </p>
              <a
                href="#bill"
                className="p-3 bg-white w-fit rounded-full text-primary-purple-200"
              >
                Start free trial
              </a>
            </div>
            <div className="w-[30%] relative ">
              <div className="absolute rounded-full md:-top-7  w-full md:h-full h-[15vh] md:-right-[50%] scale-150 md:scale-110 -right-7">
                <img
                  src={EarlyAdopter3}
                  alt=""
                  srcSet=""
                  className="object-cover object-center h-full w-full rounded-full"
                />
              </div>
            </div>
          </div>
        </AnimatedCard>

        {/* Sign up popup modal */}
        <AnimatePresence>
          {showSignupModal && (
            <motion.div
              className="fixed  top-0 bottom-0 right-0 left-0  bg-black bg-opacity-50 flex items-center justify-center z-[999] p-4"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              onClick={() => setShowSignupModal(false)}
            >
              <motion.div
                className="bg-purple-50 rounded-lg flex md:flex-row flex-col-reverse md:overflow-hidden overflow-scroll max-w-5xl w-full max-h-[90vh]"
                initial={{ scale: 0.9, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                exit={{ scale: 0.9, opacity: 0 }}
                onClick={(e) => e.stopPropagation()}
              >
                {/* Left side - form */}
                <div className="md:w-1/2  overflow-y-auto scrollbar-custom relative bg-inherit">
                  <div className="flex p-6  justify-between items-center mb-6 sticky top-0 bg-inherit z-50">
                    <button
                      onClick={() => setShowSignupModal(false)}
                      className="text-gray-600 hover:text-gray-900"
                    >
                      <span className="text-sm bg-gray-300 p-2 rounded-full flex group transition-all">
                        <Icon
                          icon="solar:arrow-right-broken"
                          className="w-5 h-5 transition-all ease-in-out duration-1000 group-hover:-rotate-12 rotate-180 group-hover:translate-x-1"
                        />
                        Go back
                      </span>
                    </button>
                    <img src={BildIcon} alt="Bildup" className="h-12 w-10" />
                  </div>

                  <div className="md:p-8 p-6 w-full">
                    <h2 className="md:text-2xl text-l font-bold md:mb-4 mb-2">
                      Get early access!
                    </h2>
                    <p className="text-gray-600 md:mb-6 mb-2 text-sm">
                      Bildup AI is currently in a private beta phase. Fill out
                      the form to get early access, and our team will get back
                      to you as soon as possible.
                    </p>

                    {/* Tab Navigation */}
                    <div className="flex space-x-4 mb-8 border-b border-gray-200">
                      <button
                        className={`pb-4 px-4 relative ${activeTab === "learner"
                            ? "text-primary-purple-200 font-semibold"
                            : "text-gray-500 hover:text-gray-700"
                          }`}
                        onClick={() => setActiveTab("learner")}
                      >
                        Parents/Learners
                        {activeTab === "learner" && (
                          <span className="absolute bottom-0 left-0 w-full h-0.5 bg-primary-purple-200"></span>
                        )}
                      </button>
                      <button
                        className={`pb-4 px-4 relative ${activeTab === "school"
                            ? "text-primary-purple-200 font-semibold"
                            : "text-gray-500 hover:text-gray-700"
                          }`}
                        onClick={() => setActiveTab("school")}
                      >
                        Schools
                        {activeTab === "school" && (
                          <span className="absolute bottom-0 left-0 w-full h-0.5 bg-primary-purple-200"></span>
                        )}
                      </button>
                    </div>

                    {/* Form Content */}
                    {activeTab === "learner" ? (
                      // Existing Parent/Learner Form
                      <form onSubmit={handleSubmit}>
                        <div className="grid grid-cols-2 gap-4 mb-4">
                          <div>
                            <label
                              htmlFor="first_name"
                              className="block text-sm font-medium text-gray-700 mb-1"
                            >
                              First name
                            </label>
                            <div className="relative">
                              <div className="absolute inset-y-0 left-3 flex items-center pointer-events-none">
                                <Icon
                                  icon="mdi:account-outline"
                                  className="text-gray-400"
                                />
                              </div>
                              <input
                                type="text"
                                id="first_name"
                                name="first_name"
                                value={formData.first_name}
                                onChange={handleChange}
                                placeholder="Your name"
                                className="py-2 pl-10 pr-3 block w-full rounded-md bg-white border-gray-200 focus:ring-primary-purple-200 focus:border-primary-purple-200"
                                required
                              />
                            </div>
                          </div>

                          <div>
                            <label
                              htmlFor="last_name"
                              className="block text-sm font-medium text-gray-700 mb-1"
                            >
                              Last name
                            </label>
                            <input
                              type="text"
                              id="last_name"
                              name="last_name"
                              value={formData.last_name}
                              onChange={handleChange}
                              placeholder="Last name"
                              className="py-2 px-3 block w-full rounded-md bg-white border-gray-200 focus:ring-primary-purple-200 focus:border-primary-purple-200"
                              required
                            />
                          </div>
                        </div>

                        <div className="mb-4">
                          <label
                            htmlFor="email"
                            className="block text-sm font-medium text-gray-700 mb-1"
                          >
                            Email
                          </label>
                          <div className="relative">
                            <div className="absolute inset-y-0 left-3 flex items-center pointer-events-none">
                              <Icon
                                icon="mdi:email-outline"
                                className="text-gray-400"
                              />
                            </div>
                            <input
                              type="email"
                              id="email"
                              name="email"
                              value={formData.email}
                              onChange={handleChange}
                              placeholder="Your email"
                              className="py-2 pl-10 pr-3 block w-full rounded-md bg-white border-gray-200 focus:ring-primary-purple-200 focus:border-primary-purple-200"
                              required
                            />
                          </div>
                        </div>

                        <div className="mb-4">
                          <label
                            htmlFor="phone"
                            className="block text-sm font-medium text-gray-700 mb-1"
                          >
                            Phone number
                          </label>
                          <input
                            type="tel"
                            id="phone"
                            name="phone"
                            value={formData.phone}
                            onChange={handleChange}
                            placeholder="Your phone"
                            className="py-2 px-3 block w-full rounded-md bg-white border-gray-200 focus:ring-primary-purple-200 focus:border-primary-purple-200"
                          />
                        </div>

                        <div className="mb-4">
                          <label
                            htmlFor="hear_about_us"
                            className="block text-sm font-medium text-gray-700 mb-1"
                          >
                            How you heard about us
                          </label>
                          <select
                            id="hear_about_us"
                            name="hear_about_us"
                            value={formData.hear_about_us}
                            onChange={handleChange}
                            className="py-2 px-3 block w-full rounded-md bg-white border-gray-200 focus:ring-primary-purple-200 focus:border-primary-purple-200"
                            required
                          >
                            <option value="" disabled>
                              How did you hear about us?
                            </option>
                            <option value="friend">Friend</option>
                            <option value="ad">Advertisement</option>
                            <option value="search">Search Engine</option>
                            <option value="other">Other</option>
                          </select>
                        </div>

                        {/* Selected plan - automatically filled */}
                        <div className="mb-4">
                          <label
                            htmlFor="selected_plan"
                            className="block text-sm font-medium text-gray-700 mb-1"
                          >
                            Selected Plan
                          </label>
                          <input
                            type="text"
                            id="selected_plan"
                            name="selected_plan"
                            value={formData.selected_plan}
                            className="py-2 px-3 block w-full rounded-md bg-gray-100 border-gray-200 text-gray-700 font-medium"
                            readOnly
                          />
                        </div>

                       
                        
                        <div className="mb-4">
                          <label
                            htmlFor="profile"
                            className="block text-sm font-medium text-gray-700 mb-1"
                          >
                            Select Your Profile
                          </label>
                          <select
                            id="profile"
                            name="profile"
                            value={formData.profile}
                            onChange={handleChange} 
                            className="py-2 px-3 block w-full rounded-md bg-white border-gray-200 focus:ring-primary-purple-200 focus:border-primary-purple-200"
                            required
                          >
                            
                            <option value="parent">Parent</option>
                            <option value="student">Student</option>
                            <option value="educator">Educator</option>
                          
                          </select>
                        </div>

                        <div className="mb-6">
                          <label
                            htmlFor="interests"
                            className="block text-sm font-medium text-gray-700 mb-1"
                          >
                            What interests you the most about Bildup AI?
                          </label>
                          <textarea
                            id="interests"
                            name="interests"
                            value={formData.interests}
                            onChange={handleChange}
                            placeholder="Enter message"
                            rows="4"
                            className="py-2 px-3 block w-full rounded-md bg-white border-gray-200 focus:ring-primary-purple-200 focus:border-primary-purple-200"
                          ></textarea>
                        </div>

                        <div className="text-center">
                          <button
                            type="submit"
                            disabled={isLoading}
                            className="inline-flex items-center justify-center px-6 py-3 border border-transparent rounded-full text-white bg-primary-purple-200 hover:bg-primary-purple-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-purple-200 transition-colors disabled:opacity-70"
                          >
                            {isLoading ? (
                              <>
                                <Icon
                                  icon="eos-icons:loading"
                                  className="animate-spin mr-2"
                                />
                                Sending...
                              </>
                            ) : (
                              <>
                                Send request
                                <Icon icon="mdi:send" className="ml-2" />
                              </>
                            )}
                          </button>
                        </div>
                      </form>
                    ) : (
                      // School Form
                      <form onSubmit={handleSchoolSubmit}>
                        <div className="mb-6">
                          <label
                            htmlFor="school_name"
                            className="block text-sm font-medium text-gray-700 mb-1"
                          >
                            School Name
                          </label>
                          <div className="relative">
                            <div className="absolute inset-y-0 left-3 flex items-center pointer-events-none">
                              <Icon
                                icon="mdi:building-outline"
                                className="text-gray-400"
                              />
                            </div>
                            <input
                              type="text"
                              id="school_name"
                              name="school_name"
                              value={schoolFormData.school_name}
                              onChange={handleSchoolChange}
                              placeholder="Enter school name"
                              className="py-2 pl-10 pr-3 block w-full rounded-md bg-white border-gray-200 focus:ring-primary-purple-200 focus:border-primary-purple-200"
                              required
                            />
                          </div>
                        </div>

                        <div className="grid grid-cols-2 gap-4 mb-6">
                          <div>
                            <label
                              htmlFor="city"
                              className="block text-sm font-medium text-gray-700 mb-1"
                            >
                              City

                            </label>
                            <div className="relative">
                              <div className="absolute inset-y-0 left-3 flex items-center pointer-events-none">
                                <Icon
                                  icon="mdi:building-outline"
                                  className="text-gray-400"
                                />
                              </div>
                              <input
                                type="text"
                                id="city"
                                name="city"
                                value={schoolFormData.city}
                                onChange={handleSchoolChange}
                                placeholder="Enter City"
                                className="py-2 pl-10 pr-3 block w-full rounded-md bg-white border-gray-200 focus:ring-primary-purple-200 focus:border-primary-purple-200"
                                required
                              />
                            </div>
                          </div>
                          <div>
                            <label
                              htmlFor="state"
                              className="block text-sm font-medium text-gray-700 mb-1"
                            >
                              State

                            </label>
                            <div className="relative">
                              <div className="absolute inset-y-0 left-3 flex items-center pointer-events-none">
                                <Icon
                                  icon="mdi:building-outline"
                                  className="text-gray-400"
                                />
                              </div>
                              <input
                                type="text"
                                id="state"
                                name="state"
                                value={schoolFormData.state}
                                onChange={handleSchoolChange}
                                placeholder="Enter State"
                                className="py-2 pl-10 pr-3 block w-full rounded-md bg-white border-gray-200 focus:ring-primary-purple-200 focus:border-primary-purple-200"
                                required
                              />
                            </div>
                          </div>
                        </div>

                        <div className="mb-6">
                          <label
                            htmlFor="country"
                            className="block text-sm font-medium text-gray-700 mb-1"
                          >
                            Country
                          </label>
                          <div className="relative country-dropdown">
                            <div className="absolute inset-y-0 left-3 flex items-center pointer-events-none">
                              {countryFlag ? (
                                <img
                                  src={countryFlag}
                                  alt="Selected country flag"
                                  className="w-5 h-4 mr-2 object-cover"
                                />
                              ) : (
                                <Icon
                                  icon="mdi:earth"
                                  className="text-gray-400"
                                />
                              )}
                            </div>
                            <input
                              type="text"
                              id="country"
                              name="country"
                              value={searchCountry}
                              onChange={(e) => {
                                setSearchCountry(e.target.value);
                                handleSchoolChange({
                                  target: {
                                    name: "country",
                                    value: e.target.value,
                                  },
                                });
                              }}
                              onFocus={() => setShowDropdown(true)}
                              onClick={() => setShowDropdown(true)}
                              placeholder="Search country"
                              className="py-2 pl-10 pr-3 block w-full rounded-md bg-white border-gray-200 focus:ring-primary-purple-200 focus:border-primary-purple-200"
                              autoComplete="off"
                              required
                            />
                            {/* Dropdown list */}
                            {showDropdown && (
                              <div className="absolute z-10 mt-1 w-full bg-white rounded-md shadow-lg max-h-60 overflow-auto">
                                {isLoadingCountries ? (
                                  <div className="px-4 py-2 text-sm text-gray-500">
                                    Loading countries...
                                  </div>
                                ) : (
                                  countries
                                    .filter((country) =>
                                      searchCountry
                                        ? country.name.toLowerCase().includes(searchCountry.toLowerCase())
                                        : true // Show all countries if no search text
                                    )
                                    .map((country) => (
                                      <div
                                        key={country.code}
                                        className="px-4 py-2 text-sm text-gray-700 hover:bg-purple-50 cursor-pointer flex items-center"
                                        onClick={() => {
                                          setSearchCountry(country.name);
                                          setCountryFlag(country.flag); // Set flag when selecting country
                                          handleSchoolChange({
                                            target: {
                                              name: "country",
                                              value: country.name,
                                            },
                                          });
                                          setShowDropdown(false);
                                        }}
                                      >
                                        <img
                                          src={country.flag}
                                          alt={`${country.name} flag`}
                                          className="w-5 h-4 mr-2 object-cover"
                                        />
                                        {country.name}
                                      </div>
                                    ))
                                )}
                              </div>
                            )}
                          </div>
                        </div>

                        <div className="grid grid-cols-1 gap-4 mb-6">
                          <div>
                            <label
                              htmlFor="first_name"
                              className="block text-sm font-medium text-gray-700 mb-1"
                            >
                              Contact Person First Name
                            </label>
                            <div className="relative">
                              <div className="absolute inset-y-0 left-3 flex items-center pointer-events-none">
                                <Icon
                                  icon="mdi:account-outline"
                                  className="text-gray-400"
                                />
                              </div>
                              <input
                                type="text"
                                id="first_name"
                                name="first_name"
                                value={schoolFormData.first_name}
                                onChange={handleSchoolChange}
                                placeholder="First name"
                                className="py-2 pl-10 pr-3 block w-full rounded-md bg-white border-gray-200 focus:ring-primary-purple-200 focus:border-primary-purple-200"
                                required
                              />
                            </div>
                          </div>

                          <div>
                            <label
                              htmlFor="last_name"
                              className="block text-sm font-medium text-gray-700 mb-1"
                            >
                              Contact Person Last Name
                            </label>
                            <input
                              type="text"
                              id="last_name"
                              name="last_name"
                              value={schoolFormData.last_name}
                              onChange={handleSchoolChange}
                              placeholder="Last name"
                              className="py-2 px-3 block w-full rounded-md bg-white border-gray-200 focus:ring-primary-purple-200 focus:border-primary-purple-200"
                              required
                            />
                          </div>
                          <div>
                            <label
                              htmlFor="contact_person_role"
                              className="block text-sm font-medium text-gray-700 mb-1"
                            >
                              Contact Person Role
                            </label>
                            <input
                              type="text"
                              id="contact_person_role"
                              name="contact_person_role"
                              value={schoolFormData.contact_person_role}
                              onChange={handleSchoolChange}
                              placeholder="Role"
                              className="py-2 px-3 block w-full rounded-md bg-white border-gray-200 focus:ring-primary-purple-200 focus:border-primary-purple-200"
                              required
                            />
                          </div>
                        </div>

                        <div className="grid grid-cols-1 gap-4 mb-6">
                          <div className="">
                            <label
                              htmlFor="email"
                              className="block text-sm font-medium text-gray-700 mb-1"
                            >
                              Contact Person Email
                            </label>
                            <div className="relative">
                              <div className="absolute inset-y-0 left-3 flex items-center pointer-events-none">
                                <Icon
                                  icon="mdi:email-outline"
                                  className="text-gray-400"
                                />
                              </div>
                              <input
                                type="email"
                                id="email"
                                name="email"
                                value={schoolFormData.email}
                                onChange={handleSchoolChange}
                                placeholder="Personal email"
                                className="py-2 pl-10 pr-3 block w-full rounded-md bg-white border-gray-200 focus:ring-primary-purple-200 focus:border-primary-purple-200"
                                required
                              />
                            </div>
                          </div>

                          <div className="">
                            <label
                              htmlFor="number"
                              className="block text-sm font-medium text-gray-700 mb-1"
                            >
                            Contact's person's Phone Number
                            </label>
                            <input
                              type="tel"
                              id="number"
                              name="number"
                              value={schoolFormData.number}
                              onChange={handleSchoolChange}
                              placeholder="Your Phone number"
                              className="py-2 px-3 block w-full rounded-md bg-white border-gray-200 focus:ring-primary-purple-200 focus:border-primary-purple-200"
                              required
                            />
                          </div>
                        </div>
                        
                        <div className="mb-6">
                          <label
                            htmlFor="hear_about_us"
                            className="block text-sm font-medium text-gray-700 mb-1"
                          >
                            How you heard about us
                          </label>
                          <select
                            id="hear_about_us"
                            name="hear_about_us"
                            value={formData.hear_about_us}
                            onChange={handleChange}
                            className="py-2 px-3 block w-full rounded-md bg-white border-gray-200 focus:ring-primary-purple-200 focus:border-primary-purple-200"
                            required
                          >
                            <option value="" disabled>
                              How did you hear about us?
                            </option>
                            <option value="friend">Friend</option>
                            <option value="ad">Advertisement</option>
                            <option value="search">Search Engine</option>
                            <option value="other">Other</option>
                          </select>
                        </div>

                        {/* Selected plan - automatically filled */}
                        <div className="mb-6">
                          <label
                            htmlFor="selected_plan"
                            className="block text-sm font-medium text-gray-700 mb-1"
                          >
                            Selected Plan
                          </label>
                          <input
                            type="text"
                            id="selected_plan"
                            name="selected_plan"
                            value={formData.selected_plan}
                            className="py-2 px-3 block w-full rounded-md bg-gray-100 border-gray-200 text-gray-700 font-medium"
                            readOnly
                          />
                        </div>

                        <div className="mb-6">
                          <label
                            htmlFor="profile"
                            className="block text-sm font-medium text-gray-700 mb-1"
                          >
                            Selected Profile
                          </label>
                          <div className="relative">
                            <div className="absolute inset-y-0 left-3 flex items-center pointer-events-none">
                              <Icon
                                icon="mdi:account-outline"
                                className="text-gray-400"
                              />
                            </div>
                            <input
                              type="text"
                              id="profile"
                              name="profile"
                              value={schoolFormData.profile}
                              readOnly
                              className="py-2 pl-10 pr-3 block w-full rounded-md bg-gray-100 border-gray-200 text-gray-700 font-medium"
                            />
                          </div>
                        </div>

                        {/* <div className="grid grid-cols-2 gap-4 mb-6">
                          <div>
                            <label
                              htmlFor="student_count"
                              className="block text-sm font-medium text-gray-700 mb-1"
                            >
                              Number of Students
                            </label>
                            <select
                              id="student_count"
                              name="student_count"
                              value={schoolFormData.student_count}
                              onChange={handleSchoolChange}
                              className="py-2 px-3 block w-full rounded-md bg-white border-gray-200 focus:ring-primary-purple-200 focus:border-primary-purple-200"
                              required
                            >
                              <option value="" disabled>
                                Select range
                              </option>
                              <option value="1-50">1-50</option>
                              <option value="51-200">51-200</option>
                              <option value="201-500">201-500</option>
                              <option value="501+">501+</option>
                            </select>
                          </div>

                          <div>
                            <label
                              htmlFor="school_email"
                              className="block text-sm font-medium text-gray-700 mb-1"
                            >
                              School Email
                            </label>
                            <div className="relative">
                              <div className="absolute inset-y-0 left-3 flex items-center pointer-events-none">
                                <Icon
                                  icon="mdi:email-outline"
                                  className="text-gray-400"
                                />
                              </div>
                              <input
                                type="email"
                                id="school_email"
                                name="school_email"
                                value={schoolFormData.school_email}
                                onChange={handleSchoolChange}
                                placeholder="Official school email"
                                className="py-2 pl-10 pr-3 block w-full rounded-md bg-white border-gray-200 focus:ring-primary-purple-200 focus:border-primary-purple-200"
                                required
                              />
                            </div>
                          </div>
                        </div> */}

                        <div className="mb-6">
                          <label
                            htmlFor="interests"
                            className="block text-sm font-medium text-gray-700 mb-1"
                          >
                            What interests you the most about Bildup AI?
                          </label>
                          <div className="flex flex-col gap-4">
                            <label className="flex items-center space-x-2">
                              <input
                                type="checkbox"
                                value="Personalized Learning"
                                onChange={handleInterestChange}
                                checked={selectedInterests.includes(
                                  "Personalized Learning"
                                )}
                              />
                              <span>Personalized Learning</span>
                            </label>
                            <label className="flex items-center space-x-2">
                              <input
                                type="checkbox"
                                value="Curriculum Alignment"
                                onChange={handleInterestChange}
                                checked={selectedInterests.includes(
                                  "Curriculum Alignment"
                                )}
                              />
                              <span>Curriculum Alignment</span>
                            </label>
                            <label className="flex items-center space-x-2">
                              <input
                                type="checkbox"
                                value="Interactive Features"
                                onChange={handleInterestChange}
                                checked={selectedInterests.includes(
                                  "Interactive Features"
                                )}
                              />
                              <span>Interactive Features</span>
                            </label>
                            <label className="flex items-center space-x-2">
                              <input
                                type="checkbox"
                                value="Progress Tracking"
                                onChange={handleInterestChange}
                                checked={selectedInterests.includes(
                                  "Progress Tracking"
                                )}
                              />
                              <span>Progress Tracking</span>
                            </label>
                          </div>
                        </div>

                        <div className="text-center">
                          <button
                            type="submit"
                            disabled={isLoading}
                            className="inline-flex items-center justify-center px-6 py-3 border border-transparent rounded-full text-white bg-primary-purple-200 hover:bg-primary-purple-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-purple-200 transition-colors disabled:opacity-70"
                          >
                            {isLoading ? (
                              <>
                                <Icon
                                  icon="eos-icons:loading"
                                  className="animate-spin mr-2"
                                />
                                Sending...
                              </>
                            ) : (
                              <>
                                Send request
                                <Icon icon="mdi:send" className="ml-2" />
                              </>
                            )}
                          </button>
                        </div>
                      </form>
                    )}
                  </div>
                </div>

                {/* Right side - image */}
                <div className="block md:w-1/2 relative h-[40vh] md:h-full">
                  <img
                    src={FormImg}
                    alt="Students learning"
                    className="w-full h-full  object-cover md:object-center"
                  />
                </div>
              </motion.div>
            </motion.div>
          )}
        </AnimatePresence>

        {/* Confirmation modal */}
        <AnimatePresence>
          {showConfirmationModal && (
            <motion.div
              className="fixed top-0 bottom-0 right-0 left-0 bg-black bg-opacity-50 flex items-center justify-center z-[999] p-4"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              onClick={() => setShowConfirmationModal(false)}
            >
              <motion.div
                className="bg-purple-50 rounded-lg flex md:flex-row flex-col-reverse md:overflow-hidden overflow-scroll max-w-5xl w-full max-h-[90vh]"
                initial={{ scale: 0.9, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                exit={{ scale: 0.9, opacity: 0 }}
                onClick={(e) => e.stopPropagation()}
              >
                {/* Left side - confirmation message */}
                <div className="md:w-1/2  flex flex-col relative bg-inherit ">
                  <div className="sticky top-0 p-6 flex justify-between items-center mb-6 bg-inherit">
                    <button
                      onClick={() => setShowConfirmationModal(false)}
                      className="text-gray-600 hover:text-gray-900"
                    >
                      <span className="text-sm bg-gray-300 p-2 rounded-full flex group transition-all">
                        <Icon
                          icon="solar:arrow-right-broken"
                          className="w-5 h-5 transition-all ease-in-out duration-1000 group-hover:-rotate-12 rotate-180 group-hover:translate-x-1"
                        />
                        Go back
                      </span>
                    </button>
                    <img src={BildIcon} alt="Bildup" className="h-12 w-10" />
                  </div>

                  <div className="p-8">
                    <h2 className="text-2xl font-bold mb-4 text-primary-purple-700">
                      Your BILDUP AI Private Access Application is Confirmed!
                    </h2>
                    <div className="bg-primary-purple-50 text-center w-full rounded-lg p-4 text-gray-700 text-sm mb-4">
                      <p className="mb-2 ">
                        Your application for access to our private beta has been
                        received. We are limiting access to selected users to
                        ensure the best experience during this early stage of
                        our release. Our team will contact you with details on
                        how to subscribe and gain full access once you are
                        selected.
                      </p>
                      <p className="mb-2">
                        As an early adopter, you will be among the first to
                        experience the transformative power of BILDUP AI in
                        helping learners, parents, and schools achieve better
                        results.
                      </p>
                      <p className="mb-2">
                        While you wait, follow us on all social media platforms{" "}
                        <span className="font-semibold">@bildupai</span> for the
                        latest updates and announcements.
                      </p>
                      <div className="mt-4">
                        <div className="font-semibold mb-1">
                          Questions? Reach out:
                        </div>
                        <div>
                          <a
                            href="mailto:support@bildup.ai"
                            className="text-primary-purple-400 underline"
                          >
                            Support@bildup.ai
                          </a>
                        </div>
                      </div>
                      <div className="mt-4">
                        <div className="font-semibold mb-1">Call or WhatsApp</div>
                        <div>
                          <a
                            href="https://wa.me/2348145678901"
                            className="text-primary-purple-400 underline"
                          >
                            Chat on Whatsapp
                          </a>
                          <span className="ml-2 text-gray-500">
                            +234 814 567 8901
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Right side - image */}
                <div className="md:w-1/2 flex items-center md:h-full h-[40vh] justify-center bg-gray-100">
                  <img
                    src={SuccessImg}
                    alt="Happy student"
                    className="w-full h-full object-cover md:object-center rounded-r-lg"
                  />
                </div>
              </motion.div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
      <Footer />
    </div>
  );
};

export default Pricing;
